import { deleteProjectDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteProjectCallable = getCallable(deleteProjectDefinition);
